import React, { useState, useEffect } from 'react';

import './Team.scss'

// Import all member photos
import memberPhoto1 from '../../assets/img/Frame 1299.jpg';
import memberPhoto2 from '../../assets/img/Frame 1298.jpg';
import memberPhoto3 from '../../assets/img/Frame 1296.jpg';
import memberPhoto4 from '../../assets/img/Frame 1292-6.jpg';
import memberPhoto5 from '../../assets/img/Frame 1292-5.jpg';
import memberPhoto6 from '../../assets/img/Frame 1292-4.jpg';
import memberPhoto7 from '../../assets/img/Frame 1292.jpg';
import memberPhoto8 from '../../assets/img/Frame 1292-2.jpg';
import memberPhoto9 from '../../assets/img/Frame 1292-3.jpg';

const teamMembers = [
  { name: 'Берик Нурымбетов', position: 'CEO', photo: memberPhoto1 },
  { name: 'Канат Сарсенбаев', position: 'CTO', photo: memberPhoto2 },
  { name: 'Евгений Чистов', position: 'Project Manager', photo: memberPhoto3 },
  { name: 'Анель Шаукер', position: 'Product Manager', photo: memberPhoto4 },
  { name: 'Бауыржан Батырбала', position: 'Product Designer', photo: memberPhoto5 },
  { name: 'Айгазы Жунисбек', position: 'Software Engineer', photo: memberPhoto6 },
  { name: 'Улан Абихан', position: 'Android Developer', photo: memberPhoto7 },
  { name: 'Алибек Бекнияз', position: 'iOS Developer', photo: memberPhoto8 },
  { name: 'Бексултан Алипов', position: 'Engineer', photo: memberPhoto9 },
];

const Team = () => {

  return (
    <>
      <section className="upper-wrapper">
        <div className="container">
          <h1 className="title title_main">
            Мы помогаем амбициозным компаниям
          </h1>
          <h2 className="subtitle subtitle_main">
            выявлять, исследовать и реагировать на новые возможности путем создания цифровых решений.
          </h2>
        </div>
      </section>

      <section className="main-block">
        <div className="container">
          <div className="main-wrapper">
            <h2 className="title main-block__title title_block">
              Команда
            </h2>
            <div className="line"></div>
          </div>
          <div className="team-wrapper">
            <div className="team-block">
              {teamMembers.map((member, index) => (
                <div className="member" key={index}>
                  <div className="member__photo">
                    <img src={member.photo} alt={member.name} />
                    <div className="member__position">
                      {member.position}
                    </div>
                  </div>
                  <div className="member__name">
                    {member.name}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Team;
